export const IMAGE_URL = `${process.env.VUE_APP_HOST}/product120/assets`

/**
 * 畫風
 */
export const Style = {
  CRAYON: 'crayon',
  PAINTING: 'painting',
  STORY: 'story',
  CARTOON: 'cartoon',
  ELEGANT: 'elegant'
} as const

export const StyleOptions = [
  {
    id: Style.PAINTING,
    label: '漫畫風',
    image: `${IMAGE_URL}/icons/${Style.PAINTING}.jpg`
  },
  {
    id: Style.CRAYON,
    label: '蠟筆風',
    image: `${IMAGE_URL}/icons/${Style.CRAYON}.jpg`
  },
  {
    id: Style.STORY,
    label: '童話風',
    image: `${IMAGE_URL}/icons/${Style.STORY}.jpg`
  },
  {
    id: Style.CARTOON,
    label: '卡通風',
    image: `${IMAGE_URL}/icons/${Style.CARTOON}.jpg`
  },
  {
    id: Style.ELEGANT,
    label: '唯美細緻風',
    image: `${IMAGE_URL}/icons/${Style.ELEGANT}.jpg`
  }
] as const

/**
 * 背景顏色
 */
export const Color = {
  GREEN: '1',
  BLUE: '2',
  YELLOW: '3',
  CAMEL: '5',
  PINK: '6',
  WHITE: '4',
  APRICOT: '7',
  PURPLE: '8'
} as const

export const ColorOptions = [
  {
    id: Color.GREEN,
    image: `${IMAGE_URL}/background/${Color.GREEN}.svg`
  },
  {
    id: Color.BLUE,
    image: `${IMAGE_URL}/background/${Color.BLUE}.svg`
  },
  {
    id: Color.YELLOW,
    image: `${IMAGE_URL}/background/${Color.YELLOW}.svg`
  },
  {
    id: Color.CAMEL,
    image: `${IMAGE_URL}/background/${Color.CAMEL}.svg`
  },
  {
    id: Color.PINK,
    image: `${IMAGE_URL}/background/${Color.PINK}.svg`
  },
  {
    id: Color.WHITE,
    image: `${IMAGE_URL}/background/${Color.WHITE}.svg`
  },
  {
    id: Color.APRICOT,
    image: `${IMAGE_URL}/background/${Color.APRICOT}.svg`
  },
  {
    id: Color.PURPLE,
    image: `${IMAGE_URL}/background/${Color.PURPLE}.svg`
  }
] as const

/**
 * 半身/全身
 */
export const Body = {
  BUST: 'A',
  FULL: 'B'
} as const

export const BodyOptions = [
  {
    id: Body.BUST,
    label: '半身'
  },
  {
    id: Body.FULL,
    label: '全身'
  }
] as const

/**
 * 無框畫尺寸
 */
export const FrameSize = {
  '20x20': '8020',
  '30x20': '8041',
  '20x30': '8040'
} as const

export const FrameSizeOptions = [
  {
    id: FrameSize['20x20'],
    label: '20x20',
    svg: {
      width: 20,
      height: 20
    }
  },
  {
    id: FrameSize['30x20'],
    label: '30x20',
    svg: {
      width: 30,
      height: 20
    }
  },
  {
    id: FrameSize['20x30'],
    label: '20x30',
    svg: {
      width: 20,
      height: 30
    }
  }
] as const

/**
 * 無框畫種類
 */
export const Frame = {
  CANVAS: '51',
  VELVET: '53',
  PHOTO: '50',
  NONE: 'none'
} as const

export const FrameOptions = [
  {
    id: Frame.CANVAS,
    label: '油畫布無框畫'
  },
  {
    id: Frame.VELVET,
    label: '絲絨柔霧無框畫'
  },
  {
    id: Frame.PHOTO,
    label: '相紙無框畫'
  },
  {
    id: Frame.NONE,
    label: '不需要無框畫',
    desc: '（僅提供電子檔）'
  }
] as const

/**
 * 方案價格
 */

export const CategoryPricing = {
  [Body.BUST]: {
    [Style.PAINTING]: 229,
    [Style.CRAYON]: 279,
    [Style.STORY]: 299,
    [Style.CARTOON]: 299,
    [Style.ELEGANT]: 399
  },
  [Body.FULL]: {
    [Style.PAINTING]: 299,
    [Style.CRAYON]: 359,
    [Style.STORY]: 399,
    [Style.CARTOON]: 399,
    [Style.ELEGANT]: 499
  }
} as const

export const FramePricing = {
  [Frame.CANVAS]: 449,
  [Frame.VELVET]: 399,
  [Frame.PHOTO]: 349,
  [Frame.NONE]: 0
} as const

/**
 * webview updateHeader動作
 */
export const HeaderMap = {
  FORM: { type: 2, title: '製作似顏繪' },
  SUMMARY: { type: 4, title: '確認訂單' },
  IMAGE: { type: 4, title: '上傳照片' },
  SUBMIT: { type: 4, title: '上傳照片' }
} as const
